<template>
  <section class="qrs-typography">
    <pageHeader class="mb--0" v-if="isapp">
      <h2 class="qrs-header-xl mt--0 mb--0">Medicines sick day guidance</h2>
    </pageHeader>
    <h1 v-if="!isapp" class="qrs-header-xl">Medicines sick day guidance</h1>
    <div class="question__nav mb--small clearfix">
      <a
        class="govuk-back-link"
        aria-label="go back to the previous screen"
        @click="goBack()"
      >
        <strong>Previous</strong>
      </a>
    </div>

    <h3>Save and share</h3>

    <div class="share_screen">
      <div id="email-sent" style="display: none">
        <div
          class="govuk-notification-banner"
          role="region"
          aria-labelledby="govuk-notification-banner-title"
          data-module="govuk-notification-banner"
        >
          <div class="govuk-notification-banner__header">
            <h2
              class="govuk-notification-banner__title"
              id="govuk-notification-banner-title"
            >
              Your email has been sent.
            </h2>
          </div>
          <div class="govuk-notification-banner__content">
            <p class="govuk-notification-banner__heading">
              If the person to whom you sent the email does not receive it,
              please:
            </p>
            <ol type="a">
              <li>Check the email address.</li>
              <li>
                Ask them to check their spam or junk folders. Note that they may
                need to transfer the email to their normal inbox in order to
                view the attached report.
              </li>
              <li>
                Ask them to add
                <a href="mailto:noreply@tactuum.com">noreply@tactuum.com</a>
                to their email whitelist.
              </li>
            </ol>
          </div>
        </div>
      </div>
      <div
        id="email-error-send"
        style="display: none"
        class="govuk-error-summary"
        aria-labelledby="error-summary-title"
        role="alert"
        tabindex="-1"
        data-module="govuk-error-summary"
      >
        <h2 class="govuk-error-summary__title" id="error-summary-title">
          Email was not sent
        </h2>
        <div class="govuk-error-summary__body">
          <p>Please try again</p>
        </div>
      </div>
      <div
        id="email-error"
        style="display: none"
        class="govuk-error-summary"
        aria-labelledby="error-summary-title"
        role="alert"
        tabindex="-1"
        data-module="govuk-error-summary"
      >
        <h2 class="govuk-error-summary__title" id="error-summary-title">
          Email was not sent
        </h2>
        <div class="govuk-error-summary__body" v-if="this.nameError">
          <p>Please check the name that you entered and try again.</p>
        </div>
        <div class="govuk-error-summary__body" v-if="this.emailAddressError">
          <p>Please check the email address that you entered and try again.</p>
        </div>
        <div class="govuk-error-summary__body" v-if="this.recipientsError">
          <p>
            Please check the recipient email(s) that you entered and try again.
          </p>
        </div>
      </div>
      <div class="share_form" id="share_form">
        <div class="govuk-form-group govuk-grid-column-one-half">
          <!-- <p>
            You can email your Medicines Sick Day Guidance Card to people who can
            help you stay well. For example - a family member, a carer, a
            healthcare professional. You will need to know their email address.
          </p> -->
          <div class="mt--24 mb--24">
            <a class="qrs-link" @click="$parent.goTo($PrivacyStatement)"
              >Privacy policy</a
            >
          </div>

          <fieldset class="govuk-fieldset">
            <div>
              <div class="mb--16">
                <label class="govuk-label" id="name-label" for="name"
                  ><strong>Your name*</strong></label
                >
                <input
                  v-model="name"
                  type="text"
                  id="name-input"
                  class="govuk-input"
                />
              </div>

              <div class="mb--16">
                <label
                  class="govuk-label"
                  id="yourEmail-label"
                  for="emailAddress"
                  ><strong>Your email address*</strong></label
                >
                <input
                  v-model="emailAddress"
                  type="email"
                  id="yourEmail-input"
                  class="govuk-input"
                />
              </div>

              <div class="mb--16">
                <label
                  class="govuk-label"
                  id="emailRecipient-label"
                  for="emailRecipient"
                  ><strong>Recipient email*</strong></label
                >
                <div id="email-hint" class="govuk-hint">
                  To add multiple recipients, enter an email address and tap on
                  'Add recipient'
                </div>
                <input
                  v-model="emailRecipient"
                  type="email"
                  id="emailRecipient-input"
                  aria-label="recipients"
                  class="govuk-input"
                />
                <div :class="{ 'govuk-button--disabled': !validRecipient }">
                  <button
                    name="Add email recipient"
                    aria-label="Add email recipient"
                    class="govuk-button govuk-button--secondary mt--24 mb--16"
                    @click="addEmail()"
                  >
                    Add recipient
                    <span class="screen-reader-text">Add email recipient</span>
                  </button>
                </div>
                <div
                  v-if="recipients.length >= 1"
                  class="emails freetext__panel mb--16"
                >
                  <span><strong>Recipients:</strong></span>
                  <div
                    class="emailtag freetext__panel__item"
                    v-for="(e, idx) in recipients"
                    @click="removeEmail(idx)"
                    :key="idx"
                  >
                    <span class="emailname">{{ e }}</span>
                    <span class="deletex freetext__panel__button"
                      ><i class="fa fa-close"></i
                    ></span>
                  </div>
                </div>

                <hr class="divider" />
              </div>
            </div>
          </fieldset>
        </div>

        <div class="mt--24">
          <button
            v-if="!isapp"
            name="share-button"
            aria-label="share-button"
            class="govuk-button mr--16"
            title="Use this button to share via email"
            @click="shareViaEmail()"
          >
            <span v-if="!emailSending">Submit</span>
            <span v-if="emailSending"
              >Sending <i class="fa fa-circle-o-notch fa-spin"></i
            ></span>
          </button>
          <button
            v-if="isapp"
            name="share-button"
            aria-label="share-button"
            class="govuk-button"
            title="Use this button to share via email"
            @click="shareViaEmail()"
          >
            <span v-if="!emailSending">Submit</span>
            <span v-if="emailSending"
              >Sending <i class="fa fa-circle-o-notch fa-spin"></i
            ></span>
          </button>
          <button
            name="cancel-button"
            aria-label="cancel-button"
            class="govuk-button govuk-button--neutral"
            title="Use this button to cancel the action"
            @click="cancelShare()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CryptoJS from "crypto-js";
import axios from "axios";
import pdfhelper from "../../components/helpers/pdfHelper.js";
// import jsonData from '../data/fields';
import helper from "../../helpers/helper.js";
//import html2canvas from 'html2canvas';

export default {
  name: "share",

  data() {
    return {
      isapp: this.$parent.isapp,
      jsonData: this.$parent.jsonData,
      answeredItems: this.$parent.answeredItems,
      testy: this.$parent.testAns,
      encrypted: "",
      unencrypted: "",
      page: 1,
      name: "",
      nameError: false,
      emailAddress: "",
      emailAddressError: false,
      emailRecipient: "",
      validRecipient: null,
      recipients: [],
      recipientsError: false,
      emailSending: false,
    };
  },
  watch: {
    emailRecipient(value) {
      // console.log(value);
      this.emailRecipient = value;
      this.validateRecipientEmail(value);
    },
  },
  methods: {
    goBack() {
      this.$parent.goTo(this.$FormSummary);
    },
    resetForm() {
      this.name = "";
      this.emailAddress = "";
      this.emailRecipient = "";
      this.recipients = [];
      this.emailSending = false;
    },
    cancelShare() {
      this.$parent.goTo(this.$FormSummary);
      this.resetForm();
    },
    validateRecipientEmail(value) {
      if (
        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          value
        )
      ) {
        this.validRecipient = true;
      } else {
        this.validRecipient = false;
      }
    },
    validateEmail(email) {
      const re =
        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    isWebview() {
      if (typeof window === undefined) {
        return false;
      }
      let navigator = window.navigator;

      const standalone = navigator.standalone;
      const userAgent = navigator.userAgent.toLowerCase();
      // console.log(userAgent);
      const safari = /safari/.test(userAgent);
      const ios = /iphone|ipod|ipad|macintosh/.test(userAgent);
      const ios_ipad_webview = ios && !safari;

      return ios
        ? (!standalone && !safari) || ios_ipad_webview
        : userAgent.includes("wv");
    },
    validateForm() {
      let errorMessage = document.getElementById("email-error");
      let nameLabel = document.getElementById("name-label");
      let emailLabel = document.getElementById("yourEmail-label");
      let recipientLabel = document.getElementById("emailRecipient-label");

      let validForm = false;

      let _hasre = false;
      let _tempentry = this.emailRecipient.trim();

      let regex =
        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (
        this.name == undefined ||
        this.name == null ||
        this.name.length == 0
      ) {
        nameLabel.style.color = "red";
        this.nameError = true;
        validForm = false;
        window.scrollTo(0, top);
      } else {
        nameLabel.style.color = "black";
        this.nameError = false;
        validForm = true;
      }

      if (
        this.emailAddress == undefined ||
        this.emailAddress == null ||
        this.emailAddress.length == 0 ||
        !this.emailAddress.match(regex)
      ) {
        emailLabel.style.color = "red";
        this.emailAddressError = true;
        validForm = false;
        window.scrollTo(0, top);
      } else {
        emailLabel.style.color = "black";
        this.emailAddressError = false;
        validForm = true;
      }

      this.emailRecipient = _tempentry;
      if (this.validateEmail(this.emailRecipient)) {
        _hasre = true;
      }
      if (_hasre && this.recipients.length < 1) {
        this.recipients.push(this.emailRecipient);
      }
      if (this.recipients.length < 1 && !_hasre) {
        recipientLabel.style.color = "red";
        window.scrollTo(0, top);
        this.recipientsError = true;
        validForm = false;
      } else {
        recipientLabel.style.color = "black";
        this.recipientsError = false;
        validForm = true;
      }

      if (this.nameError || this.emailAddressError || this.recipientsError) {
        // console.log("all fields error");
        errorMessage.style.display = "block";
        window.scrollTo(0, top);
        validForm = false;
      } else {
        errorMessage.style.display = "none";
        validForm = true;
      }

      if (validForm) {
        // console.log("send email");
        // console.log(this.jsonData);
        if (this.isWebview()) {
          // console.log("webview");
          this.sendEmailApp();
        } else {
          // console.log("not webview");
          this.sendEmailWeb();
        }
      } else {
        // console.log("Not valid Form");
      }
    },
    removeEmail(idx) {
      this.recipients.splice(idx, 1);
    },
    addEmail() {
      // console.log("add email called");
      let rep = this.emailRecipient.trim();
      if (this.validateEmail(rep)) {
        this.emailRecipient = "";
        let _eexist = false;
        this.recipients.forEach((e) => {
          if (rep.toLowerCase() === e.toLowerCase()) {
            _eexist = true;
          }
        });
        if (!_eexist) {
          this.recipients.push(rep);
          // console.log(this.recipients);
        }
      }
    },
    shareViaEmail() {
      // console.log("Share via email clicked");
      this.validateForm();
      // this.sendEmail();
    },
    sendEmailApp() {
      // console.log("send email clicked");
      this.emailSending = true;
      // console.log("email is sending...");
      let success = document.getElementById("email-sent");
      let errorMessage = document.getElementById("email-error-send");
      let shareForm = document.getElementById("share_form");

      let info = {
        name: this.name,
        email: this.emailAddress,
        date: helper.getcurrentdate(),
      };

      let doc = pdfhelper.generateJsPDF(this.answeredItems[0]);
      // console.log("pdf created");

      let htmlbody =
        "<p><strong>" +
        info.name +
        "</strong> has sent you this copy of their Medicines Sick Day Guidance Card." +
        " This card has been created using the Polypharmacy: Manage Medicines app (http://managemeds.scot.nhs.uk) provided by the Scottish Government Effective Prescribing and Therapeutics Division in collaboration with the Right Decision Service (http://rightdecision.scot.nhs.uk). </p>" +
        "<p><strong>Sender's email : </strong>" +
        info.email +
        "</p>" +
        "<p><strong>Date and time generated : </strong>" +
        info.date +
        "</p>";

      var model = {
        smtp: "smtp.sendgrid.net",
        port: 587,
        sendgrid_username: "apikey",
        sendgrid_password: "###SENDGRID###",
        to: [],
        from: {
          email: "noreply@tactuum.com",
          name: "Decision Support",
        },
        replyto: [
          {
            email: this.emailAddress,
            name: this.name,
          },
        ],
        subject: "Medicines sick day card",
        //body: btoa(htmlbody),
        body: htmlbody,
        attachments: [],
        response_title: "Email sent",
        response_body: "Your email with attachment has been sent successfully",
        response_buttontext: "Ok",
      };
      let base64pdf = doc
        .output("datauri")
        .replace("data:application/pdf;filename=generated.pdf;base64,", "");
      model.attachments.push({
        filename: "MedicinesSickDayGuidance.pdf",
        mimetype: "application/pdf",
        base64data: base64pdf,
      });
      // console.log("pdf attached");
      // console.log("base64pdf created");
      // console.log(base64pdf);

      model.to.push({ email: this.emailAddress, name: this.emailAddress });

      this.recipients.forEach((em) => {
        model.to.push({ email: em, name: em });
      });

      // console.log("emails sent to:" + " " + model.to[1]);

      // let _temp = btoa(unescape(encodeURIComponent(_unencrypted)));
      let _unencrypted = JSON.stringify(model);
      let _encrypted = this.encrypt(_unencrypted).toString();
      let _temp = btoa(_encrypted.toString());

      if (!window.flutter_inappwebview.callHandler) {
        //this instantiates some methods so that on android the loading works
        window.flutter_inappwebview.callHandler = function () {
          var _callHandlerID = setTimeout(function () {});
          window.flutter_inappwebview._callHandler(
            arguments[0],
            _callHandlerID,
            JSON.stringify(Array.prototype.slice.call(arguments, 1))
          );
          return new Promise(function (resolve, reject) {
            // console.log(typeof reject); //this line is just to avoid unused variable error
            window.flutter_inappwebview[_callHandlerID] = resolve;
          });
        };
      }

      window.flutter_inappwebview
        .callHandler("SHARE", _temp)
        .then(function (result) {
          // console.log(result);
          // console.log("success");
          window.scrollTo(0, top);
          success.style.display = "block";
          shareForm.style.display = "none";
          errorMessage.style.display = "none";
          //this.resetForm();
        })
        .catch((error) => {
          // console.log(error);
          // console.log("failed!");
          window.scrollTo(0, top);
          errorMessage.style.display = "block";
          success.style.display = "none";
          this.emailSending = false;
          //_callback({});
        });
    },
    async sendEmailWeb() {
      // console.log("send email clicked");
      this.emailSending = true;
      // console.log("email is sending...");
      let success = document.getElementById("email-sent");
      let errorMessage = document.getElementById("email-error-send");
      let shareForm = document.getElementById("share_form");

      let info = {
        name: this.name,
        email: this.emailAddress,
        date: helper.getcurrentdate(),
      };

      let pdfhtml = pdfhelper.generateHtmlforPdfWeb(this.answeredItems[0]);
      // console.log(pdfhtml);
      // let base64pdf = btoa(pdfhtml);
      let base64pdf = btoa(unescape(encodeURIComponent(pdfhtml)));

      let htmlbody =
        "<p><strong>" +
        info.name +
        "</strong> has sent you this copy of their Medicines Sick Day Guidance Card." +
        " This card has been created using the Polypharmacy: Manage Medicines app (http://managemeds.scot.nhs.uk) provided by the Scottish Government Effective Prescribing and Therapeutics Division in collaboration with the Right Decision Service (http://rightdecision.scot.nhs.uk). </p>" +
        "<p><strong>Sender's email : </strong>" +
        info.email +
        "</p>" +
        "<p><strong>Date and time generated : </strong>" +
        info.date +
        "</p>";

      var model = {
        smtp: "smtp.sendgrid.net",
        port: 587,
        sendgrid_username: "apikey",
        sendgrid_password: "###SENDGRID###",
        to: [],
        from: {
          email: "noreply@tactuum.com",
          name: "Decision Support",
        },
        replyto: [
          {
            email: this.emailAddress,
            name: this.name,
          },
        ],
        subject: "Medicines sick day card",
        body: btoa(htmlbody),
        //   body: htmlbody,
        attachments: [],
        response_title: "Email sent",
        response_body: "Your email with attachment has been sent successfully",
        response_buttontext: "Ok",
      };

      model.attachments.push({
        filename: "MedicinesSickDayGuidance.pdf",
        mimetype: "application/pdf",
        base64data: base64pdf,
      });

      model.to.push({ email: this.emailAddress, name: this.emailAddress });

      this.recipients.forEach((em) => {
        model.to.push({ email: em, name: em });
      });

      // let _temp = btoa(unescape(encodeURIComponent(_unencrypted)));
      let _unencrypted = JSON.stringify(model);

      // console.log(_unencrypted);

      let _encrypted = this.encrypt(_unencrypted).toString();

      // console.log(_encrypted);
      let _temp = btoa(_encrypted.toString());

      // console.log(_temp);

      var url = new URL(window.location.href);
      var _protocolAndDomain =
        url.protocol + "//" + url.hostname + ":" + url.port;

      axios
        .post(
          _protocolAndDomain +
            "/sendreview/?key=" +
            "###APPKEY###",
          { data: _temp.toString() },
          {
            headers: {
              "Content-Type":
                "application/x-www-form-urlencoded;charset=UTF-8;",
            },
          }
        )
        .then((r) => {
          // console.log("response:" + " " + JSON.stringify(r));
          // console.log(r.status);
          // console.log(r.data);

          if (r.status === 200 && r.data === "success") {
            // console.log("success");
            window.scrollTo(0, top);
            success.style.display = "block";
            shareForm.style.display = "none";
            this.resetForm();
          } else {
            // console.log("failed!");
            window.scrollTo(0, top);
            errorMessage.style.display = "block";
            this.emailSending = false;
          }
        })
        .catch((error) => {
          window.scrollTo(0, top);
          errorMessage.style.display = "block";
          this.emailSending = false;
          // console.log("failed2" + error);
        });
    },
    encrypt(message) {
      let res = "";
      var secret = "###SELECTPDF###";
      var key = CryptoJS.enc.Utf8.parse(secret);
      var iv = CryptoJS.enc.Utf8.parse(secret);
      res = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(message), key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      return res;
    },
    decrypt(encrypted) {
      let res = "";
      let secret = "###SELECTPDF###";
      let key = CryptoJS.enc.Utf8.parse(secret);
      let iv = CryptoJS.enc.Utf8.parse(secret);
      var bytes = CryptoJS.AES.decrypt(encrypted, key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      res = bytes.toString(CryptoJS.enc.Utf8);
      return res;
    },
  },
};
</script>
